export class DocumentsSectionsState {
  constructor(state: any) {
    this.application_id = state?.application_id;
    this.is_documents_locked = state ? JSON.parse(state.is_documents_locked) : null;
    this.documents_comment = state?.documents_comment;
  }
  application_id: number | null;
  is_documents_locked: boolean | null;
  documents_comment: string | null;
}

/* The NULL value indicates the comment is untouched or intentionally left with no value - it must be neither lock nor unlock
  https://github.com/bittner-krull/gop-web/issues/412 */
